var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-preview" }, [
    _c("div", { staticClass: "navigation" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "back-button", on: { click: _vm.close } }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("arrow_back")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c(
          "div",
          {
            staticClass: "switch-wrapper",
            class: { active: _vm.knowledgeBaseClone.enabled },
          },
          [
            _c("div", {}, [
              _vm.knowledgeBaseClone.enabled
                ? _c("div", { staticClass: "title" }, [_vm._v("Used by AI")])
                : _c("div", { staticClass: "title" }, [_vm._v("Not used")]),
            ]),
            _vm._v(" "),
            _c("a-switch", {
              attrs: {
                size: "small",
                checked: _vm.knowledgeBaseClone.enabled,
                disabled: _vm.busy,
              },
              on: { click: _vm.changeState },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { small: "", ghost: "", disabled: _vm.busy },
                on: { click: _vm.deleteKnowledgeBase },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { small: "", ghost: "", disabled: "" } },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("refresh")])]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: {
                  small: "",
                  primary: "",
                  disabled: !_vm.isChanged() || _vm.busy,
                },
                on: { click: _vm.save },
              },
              [_vm._v("\n                    Save and close\n                ")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "scroll-content" }, [
      _c("div", { staticClass: "doc-title" }, [
        _vm._v(_vm._s(_vm.knowledgeBase.webpage.title)),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "doc-link",
          attrs: { href: _vm.knowledgeBase.webpage.url, target: "_blank" },
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.knowledgeBase.webpage.url) +
              "\n        "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "doc-content" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.loading || !_vm.data
          ? _c("i", { staticClass: "material-icons spin" }, [
              _vm._v("autorenew"),
            ])
          : _c("div", {
              staticClass: "tpl-markdown markdown",
              domProps: { innerHTML: _vm._s(_vm.data.webpage.htmlContent) },
            }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-preview" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("preview")]),
      _vm._v("\n                Content preview\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }